/** @jsx jsx */
import { jsx } from '@emotion/react';

import type * as React from 'react';

import { useQuery } from '@apollo/client';
import sortBy from 'lodash/sortBy';

import DomainListContext from 'bundles/browse-common/contexts/DomainListContext';
import BrowseDomainListQueryDocumentNode from 'bundles/browse-common/queries/BrowseDomainListQuery.graphql';
import type {
  BrowseDomainListQuery,
  BrowseDomainListQueryVariables,
} from 'bundles/browse-common/queries/__generated__/BrowseDomainListQuery';

type Props = {
  children: React.ReactNode;
};

function useDomainListQuery() {
  return useQuery<BrowseDomainListQuery, BrowseDomainListQueryVariables>(BrowseDomainListQueryDocumentNode, {
    variables: {},
    context: {
      clientName: 'gatewayGql',
    },
    errorPolicy: 'all',
  });
}

const DomainListProvider = (props: Props) => {
  const { children } = props;
  const { data } = useDomainListQuery();

  const domains = sortBy(data?.Domain?.getAllDomains, (domain) => domain.name);

  return <DomainListContext.Provider value={{ domains }}>{children}</DomainListContext.Provider>;
};

export default DomainListProvider;
